import { SideContext } from '@/App';
import { SideStatus } from '@/commons/context/side-store';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import { graphicStore } from '@/commons/store/graphic-store';
import { useContext } from 'react';

import { ReactComponent as YanganqiSvg } from '@/commons/icons/new/yanganqi.svg';
import { ReactComponent as YanganqixianluSvg } from '@/commons/icons/new/yanganqixianlu.svg';
import { ReactComponent as PenlintouSvg } from '@/commons/icons/new/penlintou.svg';
import { ReactComponent as XiaohuoshuanSvg } from '@/commons/icons/new/xiaohuoshuan.svg';
import { ReactComponent as MiehuoqiSvg } from '@/commons/icons/new/miehuoqi.svg';

import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as YinyongloucengSvg } from '@/commons/icons/menu/yinyonglouceng.svg';
import { ReactComponent as YinyongzhouwangSvg } from '@/commons/icons/menu/yinyongzhouwang.svg';

import { ReactComponent as XiaofangdengjuSvg } from '@/commons/icons/menu/fire/xiaofangdengju.svg';
import { ReactComponent as XiaofangguandaoSvg } from '@/commons/icons/menu/fire/xiaofangguandao.svg';
import { ReactComponent as XiaofangshuichiSvg } from '@/commons/icons/menu/fire/xiaofangshuichi.svg';
import { ReactComponent as ZengyaqibengSvg } from '@/commons/icons/menu/fire/zengyaqibeng.svg';
import { ReactComponent as MaterialSvg } from '@/commons/icons/new/material.svg';
import { MAJOR } from '@/commons/constants/major';
import localStore from '@/commons/store/local-store';

export default function FireMenu() {
    const sideContext = useContext<SideStatus>(SideContext);

    const onClick = (route: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
    }

    const onHavcClick = (route: string, majorUuid?: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
        sideContext.setSelectedMajorUuid(majorUuid);
        localStore.setSelectedMajor(majorUuid);
    }

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongzhouwangSvg /></div>
                                <div className='name'>引用轴网</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongloucengSvg /></div>
                                <div className='name'>引用楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><XiaofangshuichiSvg /></div>
                                <div className='name'>消防水池</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZengyaqibengSvg /></div>
                                <div className='name'>增压泵</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.fire_tunnel_block) }}>
                                <div className='icon'><XiaofangguandaoSvg /></div>
                                <div className='name'>消防管道</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.spray_head) }}>
                                <div className='icon'><PenlintouSvg /></div>
                                <div className='name'>淋喷头</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><XiaofangdengjuSvg /></div>
                                <div className='name'>灯具</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.fire_extinguisher) }}>
                                <div className='icon'><MiehuoqiSvg /></div>
                                <div className='name'>消防器</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.smoke_detector) }}>
                                <div className='icon'><YanganqiSvg /></div>
                                <div className='name'>烟感器</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onClick(SIDE_TYPE.fire_shutter) }}>
                                {/* todo 更换图标 */}
                                <div className='icon'><YanganqiSvg /></div>
                                <div className='name'>防火卷帘</div>
                            </div>
                            <div className='ope-item name6' onClick={() => { onClick(SIDE_TYPE.smoke_tunnel_block) }}>
                                {/* todo 更换图标 */}
                                <div className='icon'><XiaofangguandaoSvg /></div>
                                <div className='name'>排烟送风管道</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name5 disabled' onClick={() => { }}>
                                <div className='icon'><YanganqixianluSvg /></div>
                                <div className='name'>烟感器线路</div>
                            </div>
                            <div className='ope-item' onClick={() => { onClick(SIDE_TYPE.fire_hydrant) }}>
                                <div className='icon'><XiaohuoshuanSvg /></div>
                                <div className='name'>消火栓</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onHavcClick(SIDE_TYPE.material, MAJOR.HVAC) }}>
                                <div className='icon'><MaterialSvg /></div>
                                <div className='name'>材料</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}